import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

export function OrderDeclineModal({ isOpen, onClose, onDecline }) {
  const { t } = useTranslation("delivery");
  const [reason, setReason] = useState("");

  useEffect(() => {
    setReason("");
  }, [isOpen]);

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4">

      {/* Backdrop */}
      <div
        className="absolute inset-0 bg-[#2F302C99] backdrop-blur-[2px]"
        onClick={onClose}
      />

      {/* Modal */}
      <div className="relative bg-white w-full max-w-xl rounded-2xl shadow-2xl p-10 animate-in fade-in zoom-in duration-300">

        {/* Watermark Logo */}
        <div
          className="absolute inset-0 opacity-5 pointer-events-none flex items-center justify-center"
          style={{
            backgroundImage: `url('/img/logos/logo.png')`,
            backgroundRepeat: "no-repeat",
            backgroundPosition: "center",
            backgroundSize: "45%",
          }}
        />

        <div className="relative z-10">

          {/* Title */}
          <h2 className="text-xl font-semibold text-center text-[#2F302C] mb-6">
            {t("enter_reason_for_declining")}
          </h2>

          {/* Textarea */}
          <textarea
            value={reason}
            onChange={(e) => setReason(e.target.value)}
            placeholder={t("type_your_reason_here")}
            rows={5}
            className="w-full rounded-xl border border-gray-200 
                       focus:outline-none focus:ring-2 focus:ring-[#F4B11F] 
                       focus:border-[#F4B11F] 
                       p-4 text-sm resize-none"
          />

          {/* Buttons */}
          <div className="mt-8 flex justify-between items-center px-4">

            {/* Back Button */}
            <button
              onClick={onClose}
              className="px-8 py-3 rounded-xl font-medium 
                         text-[#F4B11F] 
                         hover:underline"
            >
              {t("back")}
            </button>

            {/* Decline Button */}
            <button
              onClick={() => onDecline(reason)}
              disabled={!reason.trim()}
              className="px-16 py-3 rounded-xl border 
                         border-[#F4B11F] 
                         text-[#F4B11F] 
                         font-semibold
                         hover:bg-[#F4B11F] 
                         hover:text-white
                         transition-all duration-300
                         active:scale-95
                         disabled:opacity-50
                         disabled:cursor-not-allowed"
            >
              {t("decline")}
            </button>

          </div>

        </div>
      </div>
    </div>
  );
}

export default OrderDeclineModal;